document.addEventListener("DOMContentLoaded", function () {
    const currencySelectors = document.querySelectorAll('[data-disclosure-currency]');
    currencySelectors.forEach(function (currencySelector) {
        const currencyOptions = currencySelector.querySelectorAll('[data-disclosure-option]');
        currencyOptions.forEach(function (option) {
            option.addEventListener('click', function (event) {
                event.preventDefault();
                const currencyCode = option.getAttribute('data-value');
                const newUrl = `${window.location.origin}?currency=${currencyCode}`;
                fetchCurrency(newUrl);
            });
        });
        function fetchCurrency(newUrl) {
            fetch(newUrl)
            .then(response => {
                if (response.ok) {
                    // On a successful response, reload the current page.
                    location.reload();
                } else {
                    console.error("Failed to fetch currency data.");
                }
            })
            .catch(error => {
                console.error("Error fetching currency data: ", error);
            });
        }
    });

    // Close Search bar on header
    document.querySelector(".btn--close-search").addEventListener("click", function(e){
        e.preventDefault();
        document.querySelector(".site-header__search-container").classList.remove("is-active");
    })

    window.updateProgressBar = function(currentamount){
        if(document.querySelector("#cart-drawer-progress-bar")){ 
            if(currentamount != 0){
                currentamount = (currentamount / 100);
            }
            var threshOldValue = document.querySelector("#cart-drawer-progress-bar").max;
            document.querySelector("#cart-drawer-progress-bar").value = currentamount;
            if(currentamount == 0){
                document.querySelector(".cart-shipping__wrapper [cart_ship_notadd]").classList.remove("hidden");
                document.querySelector(".cart-shipping__wrapper [cart-shipping__num-outer]").classList.add("hidden")
                document.querySelector(".cart-shipping__wrapper [cart-shipping__success]").classList.add("hidden");
                document.querySelector(".cart-shipping__wrapper #cart-drawer-progress-bar").classList.add("hidden");
            }
            else if(currentamount < threshOldValue){
                document.querySelector(".cart-shipping__wrapper [cart_ship_notadd]").classList.add("hidden");
                document.querySelector(".cart-shipping__wrapper [cart-shipping__success]").classList.add("hidden");
                document.querySelector(".cart-shipping__wrapper [cart-shipping__num-outer] .cart-shipping__num").innerHTML = (threshOldValue - currentamount).toFixed(2);
                document.querySelector(".cart-shipping__wrapper [cart-shipping__num-outer]").classList.remove("hidden");
                document.querySelector(".cart-shipping__wrapper #cart-drawer-progress-bar").classList.remove("hidden");
            }
            else if(currentamount >= threshOldValue){
                document.querySelector(".cart-shipping__wrapper [cart_ship_notadd]").classList.add("hidden");
                document.querySelector(".cart-shipping__wrapper [cart-shipping__num-outer]").classList.add("hidden")
                document.querySelector(".cart-shipping__wrapper [cart-shipping__success]").classList.remove("hidden");
                document.querySelector(".cart-shipping__wrapper #cart-drawer-progress-bar").classList.remove("hidden");
            }
            else{
                // do else part
            }
        }
    }
});

// GTM Nav Hover Event
document.addEventListener("DOMContentLoaded", () => {
  const topLevelNavItems = document.querySelectorAll('.site-nav__link--underline');
  for (let i = 0; i < topLevelNavItems.length; i++) {
    topLevelNavItems[i].addEventListener('mouseover', function() {
      dataLayer.push({
        event: "nav_item_hover"
        });
    });
  }
});